import Vue from "vue"

Vue.filter("amount", function (value) {
    if (isNaN(value)) return ""
    return value.toFixed(2)
})

Vue.filter("percentage", function (value) {
    if (isNaN(value)) return ""
    return (value * 100).toFixed(2) + "%"
})

Vue.filter("percentage-sign", function (value) {
    if (value == null) return ""
    return `${value}  %`
})

Vue.filter('bytes', function (num) {
    if (typeof num !== 'number' || isNaN(num)) {
        throw new TypeError('Expected a number')
    }
    let exponent
    let unit
    let neg = num < 0
    let units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    if (neg) {
        num = -num
    }
    if (num < 1) {
        return (neg ? '-' : '') + num + ' B'
    }
    exponent = Math.min(Math.floor(Math.log(num) / Math.log(1000)), units.length - 1)
    num = (num / Math.pow(1000, exponent)).toFixed(2) * 1
    unit = units[exponent]
    return (neg ? '-' : '') + num + ' ' + unit
})

Vue.filter("money", function (value, currency) {
    if (!value || !currency) return ""
    return `${currency} ${value.toFixed(2)}`
})

Vue.filter("empty", function (value) {
    return value && value != "" ? value : "-"
})

Vue.filter("file_name", function (value) {
    let name = value.substring(value.lastIndexOf("/") + 1)
    return name
})

Vue.filter("pad", function (value, quantity = 3) {
    let text = typeof value != "String" ? value.toString() : value
    return text.padStart(quantity, '0')
})